import { GiftOutlined } from '@ant-design/icons';
import { Button, Card, Col, Descriptions, Form, FormInstance, InputNumber, Row, Switch, Tag } from 'antd';
import { IAddRewardsFormValues } from 'src/utils/commonInterfaces';


interface RewardsSectionProps {
    form: FormInstance<IAddRewardsFormValues>;
    rewardBalanceDisplay: string;
    onSubmit: (values: IAddRewardsFormValues) => void;
}

export const RewardsSection = ({ form, rewardBalanceDisplay, onSubmit }: RewardsSectionProps) => (
    <Card
        size="small"
        title={
            <span className="inline-flex items-center gap-2 font-medium">
                <GiftOutlined className="text-amber-500" />
                Rewards Section
            </span>
        }
        className="mb-5 rounded-lg shadow-sm"
    >
        <Descriptions
            bordered
            column={1}
            size="small"
            className="mb-6 [&_.ant-descriptions-item-label]:bg-slate-50 [&_.ant-descriptions-item-label]:font-semibold [&_.ant-descriptions-item-content]:bg-white [&_.ant-descriptions-item-content]:font-medium"
        >
            <Descriptions.Item label="Rewards Balance">
                <Tag color="gold" className="px-2.5 py-0.5 text-sm">
                    {rewardBalanceDisplay}
                </Tag>
            </Descriptions.Item>
        </Descriptions>

        <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
            initialValues={{ sendSms: true }}
            requiredMark="optional"
        >
            <Row gutter={[16, 0]}>
                <Col xs={24} md={12}>
                    <label>Rewards Amount <span>*</span></label>
                    <Form.Item
                        name="rewardsAmount"
                        rules={[
                            { required: true, message: 'Please enter the rewards amount' },
                            {
                                validator: (_, value) => {
                                    if (value === undefined || value === null) {
                                        return Promise.resolve();
                                    }
                                    if (!Number.isInteger(value)) {
                                        return Promise.reject(new Error('Whole numbers only'));
                                    }
                                    if (value < 1) {
                                        return Promise.reject(new Error('Minimum amount is 1 SAR'));
                                    }
                                    if (value > 200) {
                                        return Promise.reject(new Error('Maximum amount is 200 SAR'));
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ]}
                        extra="Enter a whole number between 1 and 200 SAR"
                    >
                        <InputNumber
                            className="w-full"
                            precision={0}
                            placeholder="Enter rewards amount"
                            addonAfter="SAR"
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                    <Form.Item
                        label="Send SMS"
                        name="sendSms"
                        valuePropName="checked"
                    >
                        <Switch checkedChildren="On" unCheckedChildren="Off" />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item className="mb-0">
                <div className="flex justify-end">
                    <Button
                        type="primary"
                        htmlType="submit"
                        icon={<GiftOutlined />}
                        size="large"
                        className="inline-flex items-center justify-center gap-2 min-w-40"
                    >
                        Add Rewards
                    </Button>
                </div>
            </Form.Item>
        </Form>
    </Card>
);
